import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  form: FormGroup;

  project:any;
  plcArray: any[] = [];

  pf: FormGroup;

  pltData: any
  searchString: any = '';
  sortby: any = 'pltNo';
  plotDetails: any;

  editFlag = false;
  soldStatus = false;
  id: any;

  currentUser:any;

  public type:any;

  isloading = true;

  constructor(
    private _formBuilder: FormBuilder,
    private SharedService: SharedService
  ) { }

  ngOnInit(): void {

    this.project = this.SharedService.getProject();
    this.currentUser = this.SharedService.getUser();

    this.dropdownList = [];
    this.selectedItems = [];
    this.dropdownSettings = {};

    this.plcArray = [];

    this.pf = this._formBuilder.group({
      pid: ['', [Validators.required]],
      length: [''],
      width: [''],
      type: ['plot'],
      inventory: [''],
      inventory_price: [''],
      carpet_area: [''],
      super_area: [''],
      plc: [''],
      base_price: [this.project.base_price],
      edc: [this.project.edc],
      gst: [this.project.gst],
      status: ['available', [Validators.required]],
    });

    this.SharedService.assetsList().subscribe((response:any) => {
      console.log(response);
      this.pltData = response.data;
      this.isloading = false;
    });



    this.dropdownList = this.project.plc;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'plc_name',
      textField: 'plc_name',
      allowSearchFilter: false
    };

    console.log(this.dropdownList)

  }


  onSelectAll(items: any) {
    this.plcArray = [];
    this.plcArray = items;
    console.log(this.plcArray);
  }

  addPlc(plc):any{
    // console.log(plc)
    let exists = false;
    this.project.plc.forEach(val => {
    if(val.plc_name === plc.plc_name){
      plc = val;
    }});
    this.plcArray.forEach(val => {
      if(val.plc_name === plc.plc_name){
        exists = true;
      }
    });
    if(exists == false){
      this.plcArray.push(plc);
    }else if (exists == true){
      this.plcArray = this.plcArray.filter(val => {
        if(val.plc_name !== plc.plc_name){
          return val;
        }
      });
    }
    console.log(this.plcArray);
  }


  onSubmit(): void {
    this.pf.patchValue({plc: this.plcArray})

    if (this.pf.invalid) {
      console.log(this.pf.value)
      this.Toast.fire({
        title: 'Error!',
        text: 'Mandatory fields are required',
        icon: 'error'
      })
      return;
    } else {
      console.log(this.pf.value)
      if( this.pf.value.type === 'plot' ){

        if(this.pf.get('length').value == '' || this.pf.get('width').value == '' || this.pf.get('carpet_area').value == '' || this.pf.get('base_price').value == '' || this.pf.get('edc').value == '' || this.pf.get('gst').value == ''){
          this.Toast.fire({
            title: 'Error!',
            text: 'All fields are required for plot',
            icon: 'error'
          })
          return;
        }else{
          this.addData();
        }

      }else if(this.pf.value.type === 'builderFloor' || this.pf.value.type === 'commercial'){
        if(this.pf.get('inventory_price').value == '' || this.pf.get('inventory').value == '' || this.pf.get('carpet_area').value == '' || this.pf.get('base_price').value == '' || this.pf.get('edc').value == '' || this.pf.get('gst').value == ''){
          this.Toast.fire({
            title: 'Error!',
            text: 'All fields are required',
            icon: 'error'
          })
          return;
        }else{
          this.addData();
        }
      }
    }

  }

  addData(){
    if (this.editFlag == false) {
      this.pf.patchValue({status: 'available'});
      console.log(this.pf.value);
      this.SharedService.createAsset(this.pf.value).subscribe((response) => {
        document.getElementById("create_close_btn").click();
        this.Toast.fire({
          title: 'Done!',
          text: 'Property has been added',
          icon: 'success'
        })
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error',
            text: error.error.data,
            icon: 'error'
          })
        })
    } else {
      this.pf.controls['pid'].enable();
      console.log(this.pf.value);
      this.SharedService.updateAsset(this.pf.value, this.id).subscribe((response) => {
        console.log(response);
        document.getElementById("create_close_btn").click();
        this.Toast.fire({
          title: 'Done!',
          text: 'Property has been updated',
          icon: 'success'
        })
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          this.pf.controls['pid'].disable();
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error',
          });
        })
    }
  }

  add(): any {
    this.pf.reset();
    this.pf.patchValue({
      status: 'available',
      base_price: this.project.base_price,
      edc: this.project.edc,
      gst: this.project.gst,
    })
    this.soldStatus = false;
    this.pf.controls['pid'].enable();
    this.plcArray = [];
    this.dropdownList = this.project.plc;
    this.editFlag = false;
    document.getElementById("btn").click();
  }

  edit(property): any {
    this.pf.patchValue(property);
    this.plcArray = property.plc;
    this.id = property._id;
    this.editFlag = true;
    this.pf.controls['pid'].disable();
    document.getElementById("btn").click();
  }

  plcCheckBox(plc,i){
    var flag = false;
    this.plcArray.forEach(val => {
      if(val.plc_name === plc.plc_name){
        flag = true;
      }
    });
    return flag;
  }

  info(plot: any): any {
    this.plotDetails = plot;
    document.getElementById("info-btn").click();

  }

  delete(plot: any): any {
    console.log(plot)
    if(plot.status !== 'available'){
      this.Toast.fire({
        title: 'Operation Not Allowed!',
        text: 'Property is associated to a customer',
        icon: 'error'
      })
    }else{
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to delete property ID ' + plot.pid,
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.SharedService.deleteAsset(plot._id).subscribe(response => {
            this.Toast.fire({
              title: 'Deleted!',
              text: 'The user has been deleted',
              icon: 'success'
            })
            this.ngOnInit();
          },
          (error)=>{
            console.log(error);
            this.Toast.fire({
              title: 'Error!',
              text: error.error,
              icon: 'error',
            });
          })
        }
      })
    }

  }

  @ViewChild('assetsTable') assetsTable: ElementRef;
  export():any{
    this.SharedService.export(this.assetsTable.nativeElement,'all-property-list');
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })



}
